import { StoryData } from '@cinch-nx/data-storyblok'
import { BrandPageStory } from '../storyblok'

export const JaecooBrandPageFallbackStory: StoryData<BrandPageStory> = {
  name: 'JAECOO',
  created_at: '2025-11-25T13:29:48.016Z',
  published_at: '2025-12-08T17:26:31.093Z',
  id: 116_276_379_762_441,
  uuid: '34e50cb0-6795-48a7-a5bc-7b8119e63195',
  content: {
    SEO: [
      {
        _uid: 'ef61d211-0f42-4195-95cd-c2d034d2ef0b',
        HowTo: [],
        title: 'JAECOO | Latest JAECOO cars',
        robots: [],
        component: 'SEO',
        openGraph: [],
        description:
          'Learn about JAECOO. Cutting-edge petrol, hybrid and electric cars filled with the latest tech at affordable prices. Find out more.',
        twitterCard: [],
        canonicalUrl: '',
      },
    ],
    _uid: 'c5a68e03-b65d-4a47-8002-0d4da88acfb6',
    body: [
      {
        _uid: '3cc5e802-84ca-4f31-8ca5-978039a0247e',
        content: [
          {
            _uid: '9498d568-aa2c-4f43-bbe8-e019de1af474',
            text: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Explore JAECOO, modern SUVs that blend luxury, technology and off-road capability. Petrol, hybrid and electric options bring rugged confidence and contemporary design to every journey.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: "We're partnering with Marshall Motor Group, one of the UK's leading automotive retailers, to sell brand new JAECOO cars. Discover more below, then shop the range and submit your enquiry – the Marshall team will be in touch to discuss how to test drive and buy.",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            component: 'RichText',
          },
          {
            url: '/new-cars/jaecoo/',
            _uid: 'dadecc1b-9359-4077-a91a-3945914cb3a5',
            label: 'Buy a brand new JAECOO car',
            component: 'CtaButton',
          },
        ],
        component: 'IntroSection',
      },
      {
        _uid: 'b3a2389f-8c1a-4822-9c23-7f40d2d64c63',
        component: 'LandingTextInlineImageSection',
        textInlineImages: [
          {
            _uid: '9ac25312-1846-446b-9a8a-ed567d652ca0',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'JAECOO 7',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The JAECOO 7 is a bold SUV with modern luxury and undeniable allure. It combines classic touches with cutting-edge tech to tackle every adventure. Plus the choice of all-wheel drive for smart traction on and off-road.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Available with a 1.6-litre petrol engine or as a Super Hybrid with 700 miles of combined range (56 miles electric-only), you can enjoy class-leading efficiency in an elegant yet bold package.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 116_685_906_521_915,
              alt: 'Green JAECOO 7 driving through a river with trees in the background',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x400/5e02d2cf29/jaecoo-7-model.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Green JAECOO 7 driving through a river with trees in the background',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
          },
          {
            _uid: 'ffc689b4-3115-44e9-9d6a-ab16c75d5740',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'JAECOO 5',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'A confident crossover driven by a 1.6-litre petrol heart, the JAECOO 5 is inspired by mountain strength. Its next-gen engineering offers confidence on any terrain, making it the perfect companion for active households.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'A 1.45m² panoramic sunroof floods the cabin with light, while options like in-car karaoke show its playful side.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 116_685_895_102_265,
              alt: 'Green JAECOO 5 SUV driving down a country road',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x400/36b9b0b4c2/jaecoo-5-model.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Green JAECOO 5 SUV driving down a country road',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
          },
          {
            _uid: 'a7092b0c-532f-45e8-a074-2ec856949124',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'JAECOO E5',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'For a poised, powerful electric crossover with up to 248 miles of range, consider the JAECOO E5. Conquer every road with confidence and enjoy its rugged styling inside and out.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The E5 is innovation in motion, sharing its creature comforts with the petrol-powered 5, but benefitting from the quiet elegance and everyday usability of its electric powertrain.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 116_689_956_786_275,
              alt: 'Black JAECOO E5 SUV parked on grass surrounded by hills',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/500x400/79c64adecc/jaecoo-e5-model.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Black JAECOO E5 SUV parked on grass surrounded by hills',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
          },
        ],
      },
      {
        url: '/new-cars/jaecoo/',
        _uid: '5a6e430d-1473-413c-97e9-f08eb5829142',
        label: 'Shop JAECOO',
        component: 'CtaButton',
      },
      {
        _uid: 'c809c8d2-65db-4a05-9e21-904cd67faac7',
        title: 'Why choose JAECOO?',
        component: 'HighlightsSection',
        highlights: [
          {
            _uid: '645c100a-4a59-48f8-9947-9297735841bf',
            body: 'Optional intelligent all-road drive system is confident in all conditions.',
            icon: 'range',
            title: 'Off-road credentials',
            component: 'FeatureCard',
          },
          {
            _uid: 'ba7e900a-8947-4158-8192-1a2a730cf7e6',
            body: 'Class-leading efficiency from blade cell design batteries and Super Hybrid Systems.',
            icon: 'electric',
            title: 'Electric innovation',
            component: 'FeatureCard',
          },
          {
            _uid: 'b8f0f15b-7554-4cb6-9c34-41626c9e0e8f',
            body: 'A 7-year / 100,000-mile warranty is standard on all brand new JAECOO models.',
            icon: 'heart-outline',
            title: 'Peace of mind',
            component: 'FeatureCard',
          },
        ],
      },
      {
        _uid: 'ebb46ab4-3385-4e0a-ac4f-e527776c5b38',
        make: 'jaecoo',
        title: 'Shop new cars',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '38000',
        component: 'CarsCarousel',
        priceFrom: '',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        carsCondition: 'new',
        showMonthlyPrices: true,
        showOnlyCinchStock: false,
        financeRepresentativeExample: ['8ad927dd-38b7-4d0d-8760-302c0243ecc5'],
      },
      {
        _uid: 'ac3be847-d2fe-4b93-970e-a5cbb5e0977b',
        faqs: [
          {
            _uid: '51857869-8f41-448c-92a2-949c1571dd91',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Search our range of ',
                      type: 'text',
                    },
                    {
                      text: 'brand new cars',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/new-cars',
                            uuid: null,
                            anchor: null,
                            target: '_blank',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ', then submit our quick enquiry form and the Marshall team will call you back to discuss your purchase.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can also visit our new car stores to discover some of the most exciting brands emerging in the UK.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch Chery:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Chery Gatwick',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/gatwick',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Chery Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Chery Medway',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-medway',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch OMODA & JAECOO:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'OMODA & JAECOO Bristol',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/bristol',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'OMODA & JAECOO Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/omoda-jaecoo-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'We’re partnering with Marshall Motor Group to bring our customers brand new cars.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Marshall has over 115 years of motoring know-how and is one of the UK’s largest motor retailers, so our customers benefit from the shared experience of both brands.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title: 'How can I buy a new car on cinch?',
            component: 'AccordionItem',
          },
          {
            _uid: 'e811e555-9f5b-4814-83c2-2af4432162e8',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Of course, you can test drive new cars at the stores below. You’ll find addresses, opening hours and contact details when you click the relevant link.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Marshall BYD stores:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Ashford',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-ashford/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Canterbury',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-canterbury/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Maidstone',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-maidstone/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Northampton',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-northampton/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Peterborough',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-peterborough/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'St Neots',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-st-neots/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch Chery Stores:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Gatwick',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/gatwick',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Medway',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-medway',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch OMODA & JAECOO Stores:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Bristol',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/bristol',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/omoda-jaecoo-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'Can I test drive a new car?',
            component: 'AccordionItem',
          },
          {
            _uid: 'dd53dcaa-67cc-4198-8865-c09c0cc93f48',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can pay for a new car however it suits you – buy outright or on finance (Hire Purchase or Personal Contract Purchase).',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Since your purchase is handled by Marshall Motor Group, one of the UK’s largest motor retailers, they’ll talk you through your options after you submit your enquiry.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'What are my payment options when buying a new car?',
            component: 'AccordionItem',
          },
          {
            _uid: 'ceecb699-882c-4263-a36e-f8dfb01a8346',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The Marshall team will talk you through your options for delivery and/or collection – and how long they’ll take – when they call you back after your enquiry.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'How can I get my new car?',
            component: 'AccordionItem',
          },
        ],
        title: 'Frequently Asked Questions',
        component: 'FaqSection',
      },
    ],
    hero: [
      {
        _uid: 'a68d9580-d677-46ba-9bff-5551d68f435e',
        logo: {
          id: 116_685_542_104_885,
          alt: 'JAECOO brand logo in white',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/1696x263/96492921c5/jaecoo-logo-white.svg',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'JAECOO brand logo in white',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        image: {
          id: 116_685_898_809_146,
          alt: 'White JAECOO SUV',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/1200x600/19f33e0a8b/jaecoo-brand-page-hero.webp',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'White JAECOO SUV',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        heading: 'Adventure starts with JAECOO',
        component: 'LandingHero',
        ctaButton: [
          {
            url: '/new-cars/jaecoo/',
            _uid: '415126d8-7e9e-45a5-97ef-88ee8ff56fcd',
            label: 'Shop new JAECOO',
            component: 'HeroCtaButton',
          },
        ],
      },
    ],
    component: 'LandingPage',
  },
  slug: 'jaecoo',
  full_slug: 'landing/jaecoo',
  sort_by_date: null,
  position: -20,
  tag_list: [],
  is_startpage: false,
  parent_id: 96_553_270_937_130,
  meta_data: null,
  group_id: 'd8fb248f-62ff-4cea-bbeb-0f504644c3c2',
  first_published_at: '2025-11-26T12:00:54.608Z',
  lang: 'default',
  path: 'jaecoo',
  alternates: [],
}
